/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Comparison_Product_Hunt_DescriptionInputs */

const en_directory_comparison_product_hunt_description = /** @type {(inputs: Directory_Comparison_Product_Hunt_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product Hunt is built around launch-day attention. Seek AI focuses on keeping product information discoverable after the launch.`)
};

const zh_directory_comparison_product_hunt_description = /** @type {(inputs: Directory_Comparison_Product_Hunt_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product Hunt 围绕发布日关注度构建；Seek AI 更关注产品发布之后仍能持续被发现。`)
};

/**
* | output |
* | --- |
* | "Product Hunt is built around launch-day attention. Seek AI focuses on keeping product information discoverable after the launch." |
*
* @param {Directory_Comparison_Product_Hunt_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_comparison_product_hunt_description = /** @type {((inputs?: Directory_Comparison_Product_Hunt_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Comparison_Product_Hunt_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_comparison_product_hunt_description(inputs)
	return zh_directory_comparison_product_hunt_description(inputs)
});
export { directory_comparison_product_hunt_description as "directory.comparison.product_hunt.description" }